import { apiGet } from '@/store/api';
import { usePortcallStore } from '@/store/portcallStore';

export async function getBerths(callId: string | number) {
  const result = await apiGet(`dock/berths/${callId}`);
  if (result.resultCategory == 1) {
    usePortcallStore().setBerths(result.payload);
  }
}
